import { createContext, useContext, useState, useCallback, useRef } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { BrutalButton } from "@/components/Brutal";
import { AlertTriangle, Bell } from "lucide-react";

const ConfirmContext = createContext(() => Promise.resolve(false));
export const useConfirm = () => useContext(ConfirmContext);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);
  const resolver = useRef(null);

  const confirm = useCallback((opts = {}) => {
    setState({
      title: opts.title || "Weet je het zeker?",
      description: opts.description || "",
      confirmLabel: opts.confirmLabel || "Verwijderen",
      cancelLabel: opts.cancelLabel || "Annuleren",
      tone: opts.tone || "danger",
    });
    return new Promise((resolve) => { resolver.current = resolve; });
  }, []);

  const close = (val) => { setState(null); if (resolver.current) { resolver.current(val); resolver.current = null; } };
  const info = state?.tone === "info";
  const Icon = info ? Bell : AlertTriangle;

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <Dialog open={!!state} onOpenChange={(o) => { if (!o) close(false); }}>
        <DialogContent className="brutal border-2 border-brand-ink bg-white rounded-xl max-w-sm" data-testid="confirm-dialog">
          {state && (
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className={`brutal-sm rounded-xl p-2.5 shrink-0 ${info ? "bg-brand-yellow" : "bg-brand-pink"}`}>
                  <Icon className="w-6 h-6" strokeWidth={2.5} />
                </div>
                <div>
                  <h3 className="font-head font-black text-xl leading-tight" data-testid="confirm-title">{state.title}</h3>
                  {state.description && <p className="text-sm text-brand-ink/60 mt-1">{state.description}</p>}
                </div>
              </div>
              <div className="flex gap-2">
                <BrutalButton variant="white" className="flex-1" data-testid="confirm-cancel" onClick={() => close(false)}>{state.cancelLabel}</BrutalButton>
                <BrutalButton variant={info ? "primary" : "danger"} className="flex-1" data-testid="confirm-ok" onClick={() => close(true)}>{state.confirmLabel}</BrutalButton>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </ConfirmContext.Provider>
  );
}
